<template>
  <div class="product-box">
    <div class="extra-tag-10" v-if="showExtraRateIcon"></div>
    <div
      class="product-item"
      :data-productid="item.PRODUCT_ID"
      :pointValue="item.PRODUCT_ID + ';' + item.CP_PRODUCT_ID"
    >
      <div class="tag-wrap">
        <span class="product-tag" v-if="extraTip(item)">{{
          extraTip(item)
        }}</span>
        <span class="product-tag coupon" v-if="+item.COUPON">{{
          letter.couponCanUseQuan
        }}</span>
        <!-- 2024.5.21 日本江美新增自选礼包标签 -->
        <span
          class="product-tag coupon"
          v-if="+gameId === 2 && item.CP_PRODUCT_EXT.TYPE === 'self-selected'"
          >自選パック</span
        >
        <span
          class="product-tag"
          v-if="[211].includes(+gameId) && item.PRODUCT_TAG"
          >{{ item.PRODUCT_TAG }}</span
        >
      </div>
      <div class="detail-wrap">
        <div class="left">
          <div class="text">
            <p class="product-name img-name" v-if="+gameId === 2">
              <img
                class="product-name-img"
                :src="getBeautyNameIco(item.PRODUCT_ICON)"
                :alt="item.PRODUCT_ICON"
                @error="beautyNameIcoError($event, item.PRODUCT_ICON)"
              />
            </p>
            <p class="product-name name" v-else>
              {{ getProductName(item) }}
            </p>
          </div>
          <prop-img :item="item" @chooseProp="chooseProp"></prop-img>
        </div>
        <div class="right" :class="{ flexEnd: !showAddCartBtn }">
          <div class="product-price" v-if="isCart">
            <template
              v-if="
                item.amountLevel &&
                item.amountLevel.TRANS_AMOUNT &&
                item.amountLevel.SHOW_CURRENCY
              "
              >{{ item.amountLevel.TRANS_AMOUNT
              }}{{ item.amountLevel.SHOW_CURRENCY }}</template
            >
          </div>
          <p class="product-price" v-else>
            {{ item.GAME_AMOUNT }}{{ currency }}
          </p>
          <div
            class="cart-buy j-click-add-to-cart-product-list"
            v-if="showAddCartBtn"
            @click="
              canBuy && handleProductIntercept(item) && addToCart($event, item)
            "
          >
            {{ letter.add_to_cart }}
          </div>
          <div
            class="normal-buy j-select-product"
            :class="{ 'can-not-use-cart': !showAddCartBtn }"
            :data-productid="item.PRODUCT_ID"
            :pointValue="item.PRODUCT_ID + ';' + item.CP_PRODUCT_ID"
            @click="
              canBuy && handleProductIntercept(item) && selectProduct(item)
            "
          >
            {{ letter.couponBuyNow }}
          </div>
        </div>
        <prop-popup
          v-if="showPropPopup"
          v-clickoutside="hideProp"
          :detail="nowActivePropDetail"
          class="prop-detail-popup"
        ></prop-popup>
      </div>
      <!-- 2024.5.21 日本江美新增自选礼包提示 -->
      <div
        class="custom-gift-bag-tip"
        v-if="+gameId === 2 && item.CP_PRODUCT_EXT.TYPE === 'self-selected'"
      >
        上記は選択可能なアイテムの一部です。詳細はゲーム内をご確認ください。
      </div>
    </div>
    <PopupWindow
      v-if="visibleTipPopup"
      type="tips"
      :languages="letter"
      :title="popupTitle"
      :content="popupTip"
      :confirm="popupConfirm"
      textAlign="center"
      @onConfirm="visibleTipPopup = false"
      @onCancel="visibleTipPopup = false"
    ></PopupWindow>
  </div>
</template>

<script>
import cartAddAndDetail from '@mixins/officialStore/cartAddAndDetail';
import PropImg from '@components/officialStore/product/PropImg.vue';
import PropPopup from '@components/officialStore/product/PropPopup.vue';
import clickOutside from '../../../diractives/officialStore/clickOutside';
import { mapState } from 'vuex';
import product from '@mixins/officialStore/product';
import { getPayTYpeListStore } from '@store/officialStore/storager';
import propImg from '@mixins/officialStore/propImg';
import productName from '@mixins/product';
export default {
  name: 'ProductItem',
  mixins: [cartAddAndDetail, product, propImg, productName],
  props: ['item', 'canBuy'],
  data() {
    return {
      visibleTipPopup: false,
      popupTitle: '',
      popupTip: '',
      popupConfirm: '',
      showPropPopup: false,
      nowActivePropDetail: ''
    };
  },
  computed: {
    ...mapState({
      ipLocation: state => state.ipLocation,
      gameId: state => state.gameId,
      isCart: state => state.cart.isCart,
      canUseCart: state => state.cart.canUseCart,
      letter: state => state.letter,
      currency: state => state.showCurrency
    }),
    showAddCartBtn() {
      const payTypeList = getPayTYpeListStore();
      // canUseCart是说这个用户能不能使用购物车，payTypeList是这个渠道能不能用购物车，需要两者同时决定
      return payTypeList && payTypeList.length > 0 && this.canUseCart;
    },
    // 展示额外加码icon
    showExtraRateIcon() {
      return this.gameId == 285;
    }
  },
  methods: {
    selectProduct(item) {
      this.$emit('selectProduct', item);
    },
    handleProductIntercept(item) {
      // 2024.11.26 需求人：邓智轩、苏忠丽 PNS针对俄罗斯ip玩家，拦截指定商品id的购买
      const interceptProductIdList = [
        'ztm.app.credit37',
        'ztm.app.credit38',
        'ztm.app.credit39',
        'ztm.app.credit40',
        'ztm.app.credit41',
        'ztm.app.credit42',
        'ztm.app.credit43',
        'ztm.app.credit44',
        'ztm.app.credit45',
        'ztm.app.credit46'
      ];
      if (
        +this.gameId === 191 &&
        this.ipLocation === 'RU' &&
        interceptProductIdList.includes(item.PRODUCT_ID)
      ) {
        this.showTipPopup();
        return false;
      }
      return true;
    },
    showTipPopup() {
      this.popupTitle = this.letter.productInterceptPopupTitle;
      this.popupTip = this.letter.productInterceptPopupTip;
      this.popupConfirm = this.letter.productInterceptPopupConfirm;
      this.visibleTipPopup = true;
    },
    chooseProp(prop) {
      this.nowActivePropDetail = prop;
      this.showPropPopup = true;
    },
    hideProp() {
      this.showPropPopup = false;
    }
  },
  components: {
    PropImg,
    PropPopup
  },
  directives: {
    clickoutside: clickOutside
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.product-box {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  padding: 0 24px;
  .extra-tag-10 {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 1;
    width: 65px;
    height: 65px;
    background: url($imgStore + 'extra-tag-10.png') no-repeat top;
    background-size: cover;
  }
}
.product-item {
  display: flex;
  overflow: hidden;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: 19px;
  padding: 15px 12px 22px;
  background-size: 100% 100%;
  cursor: pointer;
  @psetbg ('product-item-bg.png', false, false);
  .tag-wrap {
    border-bottom: 2px solid var(--product-item-fenge-line);
    height: 41px;
    .product-tag {
      margin-right: 16px;
      padding: 5px 15px;
      border: 1px solid var(--product-item-tag-border);
      background: var(--product-item-tag-bg);
      font-size: 20px;
      color: var(--product-item-tag-text);
      &.coupon {
        border: 1px solid var(--product-item-tag-coupon-border);
        background: var(--product-item-tag-coupon-bg);
        color: var(--product-item-tag-coupon-text);
      }
    }
  }
  .detail-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 449px;
      .img-name {
        line-height: auto;
      }
      .img-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 18px;
        width: 100px;
        height: 100px;
        background: url($pnsImg + 'product.png') no-repeat top;
        background-size: cover;
        .product-icon {
          width: 80%;
          height: auto;
        }
      }
      .text {
        display: flex;
        margin-bottom: 50px;
        width: 100%;
        .product-name {
          line-height: 30px;
          /*!rtl:ignore*/
          direction: ltr;
          font-size: 24px;
          color: var(--product-item-name);
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: end;
      width: 202px;
      .cart-buy {
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: cover;
        cursor: pointer;
        font-size: 24px;
        color: var(--product-item-btn);
        white-space: nowrap;
        @psetbg ('cart-buy.png');
      }
      .normal-buy {
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: cover;
        cursor: pointer;
        font-size: 24px;
        color: var(--product-item-btn);
        white-space: nowrap;
        @psetbg ('normal-buy.png');
        &.can-not-use-cart {
          margin-bottom: 28px;
        }
      }
      .product-price {
        margin-right: 23px;
        font-size: 30px;
        color: var(--product-item-price);
      }
    }
    .prop-detail-popup {
      position: absolute;
      left: 50%;
      top: 20px;
      transform: translateX(-50%);
    }
  }
  .custom-gift-bag-tip {
    margin-top: 5px;
    height: 17px;
    font-size: 17px;
    line-height: 17px;
  }
}
.product-name-img {
  font-size: 14px;
}
@media screen and (orientation: landscape) {
  .product-box {
    margin-left: 30px;
    padding: 0;
    &:nth-child(2n + 1) {
      margin-left: 0;
    }
  }
  .product-item {
    padding: 16px 10px;
    .tag-wrap {
      height: 32px;
      .product-tag {
        font-size: 16px;
      }
    }
    .detail-wrap {
      .left {
        width: 378px;
        .img-wrap {
          width: 84px;
          height: 84px;
          background: url($pnsImg + 'product-hen.png') no-repeat top;
          background-size: cover;
        }
        .text {
          margin-bottom: 41px;
        }
      }
      .right {
        width: 188px;
        .cart-buy {
          font-size: 20px;
          @psetbg ('cart-buy-hen.png');
        }
        .normal-buy {
          font-size: 20px;
          @psetbg ('normal-buy-hen.png');
        }
        .product-price {
          font-size: 24px;
        }
      }
    }
    .custom-gift-bag-tip {
      margin-top: 5px;
      height: 40px;
      font-size: 16px;
      line-height: 20px;
    }
  }
}
</style>
